import engineUserAgent from './engine-user-agent.js';

var userAgent = engineUserAgent;
var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

export { engineIsWebosWebkit as default };
